import { Modal as PDPDialog } from '../../components/Modal';

function extractAttribute(el, attr) {
  return (el.getAttribute(attr) || '').trim();
}

const klarnaModal = () => {
  let dialogObj = null;

  function openKlarnaModal(learnUrl) {
    const iframe = document.querySelector('[data-klarna-iframe]');
    if (!iframe) return;

    // Modify the URL to change showButtons=false to showButtons=true
    if (learnUrl) {
      try {
        const urlObj = new URL(learnUrl);
        const params = urlObj.searchParams;

        // Change showButtons to true only if it's not already true
        if (params.has('showButtons') && params.get('showButtons') !== 'true') {
          params.set('showButtons', 'true');
        }

        // Reconstruct the URL with modified params
        learnUrl = urlObj.toString();
      } catch (e) {
        console.warn('[KlarnaOSM] Failed to parse URL:', e);
      }

      // Set iframe src
      iframe.src = learnUrl;
    }

    // Create dialog instance if it doesn't exist
    if (!dialogObj) {
      dialogObj = new PDPDialog('klarna-learn-modal', { cleanContent: false, animation: false });

      // Setup close handler with beforeClose callback to preserve iframe content
      dialogObj.setClose(() => {
        // Clear iframe src when modal closes
        if (iframe) iframe.src = '';
      });
    }

    // Open modal
    dialogObj.show();
  }

  // Handle "Learn More" button clicks
  document.addEventListener('click', function (event) {
    const button = event.target && event.target.closest && event.target.closest('.pdp-c-atc__klarna-learn-btn');
    if (!button) return;
    event.preventDefault();
    // Get the learn more URL from the data attribute
    const el = document.querySelector('[data-klarna-osm]');
    const learnUrl = extractAttribute(el, 'data-klarna-learn-url');

    openKlarnaModal(learnUrl);
  });

  // Listen for Klarna iframe CLOSE messages
  window.addEventListener('message', function (event) {
    // Ensure the message comes from Klarna
    if (event.origin !== 'https://payments.klarna.com') return;

    const iframe = document.querySelector('[data-klarna-iframe]');

    // Parse event.data if it's a JSON string
    let data = event.data;
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) {
        return;
      }
    }

    // Check if it's a CLOSE event
    if (!data || data.type !== 'CLOSE') {
      const modal = document.querySelector('klarna-qv-modal');
      if (modal) modal.remove();
    }

    if (dialogObj && dialogObj.node?.open) {
      // Use the Modal class's built-in close mechanism
      dialogObj.handleCloseModalClick(() => {
        // Clear iframe src when modal closes
        if (iframe) iframe.src = '';
      });
    }
  });
};

export default klarnaModal;
